import request from '@/api/request'

export default {
  /**
   * Busca as contas cadastradas conforme filtros
   *
   * @param options
   * @returns {Promise<*>}
   */
  async getAccounts (options) {
    return (await request.get(`module/action/marketplace/magalu/account/index`, {
      params: options
    })).data
  },
  /**
   * Retorna uma conta de acordo com o identificador
   *
   * @param identifier
   * @returns {Promise<*>}
   */
  async getAccountByIdentifier (identifier) {
    return (await request.get(`module/action/marketplace/magalu/account/getOneById/${identifier}`)).data
  },
  /**
   * Realiza o refresh de um access_token de uma conta no marketplace manualmente
   *
   * @param identifier
   * @returns {Promise<*>}
   */
  async refreshTokenManually (identifier) {
    return (await request.get(`module/action/marketplace/magalu/account/refreshTokenManually/${identifier}`)).data
  },
  /**
   * Atualiza o status da conta do TikTok Shop.
   *
   * @param {String} identifier
   * @param {Boolean} status
   * @returns {Object}
   */
  async updateAccountStatus (identifier, status) {
    if (status) {
      return (await request.get(`module/action/marketplace/magalu/account/activate/${identifier}`)).data
    }

    return (await request.get(`module/action/marketplace/magalu/account/deactivate/${identifier}`)).data
  },
  /**
 * Deleta uma conta de acordo com o identifier.
 *
 * @param identifier
 * @returns {Promise<*>}
 */
  async deleteAccount (identifier) {
    return (await request.get(`module/action/marketplace/magalu/account/delete/${identifier}`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/magalu/index.js